var map = {
	"./DSCF6470.jpg": 2612,
	"./DSCF6488.jpg": 7941,
	"./DSCF6499.jpg": 9526,
	"./DSCF6511.jpg": 8917,
	"./DSCF6516.jpg": 385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7391;